import { Link } from "react-router-dom";
import DashboardHeader from "./components/dashboard/DashboardHeader";
import SearchCard from "./components/dashboard/cards/SearchCard";
import FeaturedBuildCard from "./components/dashboard/cards/FeaturedBuildCard";
import SectionHeader from "./components/dashboard/SectionHeader";
import PageTransition from "./components/PageTransition";
import PageLayout from "./components/PageLayout";

function DashboardHome() {
  return (
    <PageTransition>
      <PageLayout>
        <DashboardHeader />

        <div style={searchSpacingStyle}>
          <SearchCard />
        </div>

        <div style={sectionSpacingStyle}>
          <SectionHeader
            title="Today's Featured Build"
            link="/discover"
            linkText="Browse Builds"
          />

          <FeaturedBuildCard />
        </div>

        <div style={sectionSpacingStyle}>
          <SectionHeader title="Spotlight" link="/spotlight" />

          <Link to="/spotlight" style={spotlightCardStyle}>
            <span style={spotlightIconStyle}>💡</span>

            <div style={{ flex: 1 }}>
              <strong>Explore Spotlight</strong>
              <p style={miniTextStyle}>
                Trending parts, popular brands, and featured builds from the
                community.
              </p>
            </div>

            <span style={arrowStyle}>→</span>
          </Link>
        </div>

        <div style={sectionSpacingStyle}>
          <SectionHeader title="Quick Actions" />

          <div style={quickGridStyle}>
            <Link to="/garage" style={quickCardStyle}>
              <span style={quickIconStyle}>🚗</span>
              <span>Open Garage</span>
            </Link>

            <Link to="/for-sale" style={quickCardStyle}>
              <span style={quickIconStyle}>🏷️</span>
              <span>For Sale</span>
            </Link>
          </div>
        </div>
      </PageLayout>
    </PageTransition>
  );
}

const searchSpacingStyle = {
  marginTop: "32px",
};

const sectionSpacingStyle = {
  marginTop: "48px",
};

const miniTextStyle = {
  margin: "6px 0 0",
  opacity: 0.65,
  fontSize: "13px",
  lineHeight: "1.4",
};

const quickGridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "12px",
};

const quickCardStyle = {
  backgroundColor: "#181818",
  border: "1px solid #2a2a2a",
  borderRadius: "18px",
  padding: "16px",
  textDecoration: "none",
  color: "white",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const quickIconStyle = {
  fontSize: "22px",
};

const spotlightCardStyle = {
  backgroundColor: "#181818",
  border: "1px solid #2a2a2a",
  borderRadius: "18px",
  padding: "18px",
  textDecoration: "none",
  color: "white",
  display: "flex",
  alignItems: "center",
  gap: "14px",
};

const spotlightIconStyle = {
  width: "48px",
  height: "48px",
  borderRadius: "999px",
  backgroundColor: "rgba(225,6,0,0.12)",
  color: "#e10600",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "22px",
  flexShrink: 0,
};

const arrowStyle = {
  fontSize: "22px",
  color: "#666",
};

export default DashboardHome;